export default __webpack_public_path__ + "2eeecb8b2504203a294bc7acf4b8fed7.png";